export default "__VITE_ASSET__CYqg$eyK__"